import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';

import { forwardRef } from 'react';

import { Box, Heading } from '@chakra-ui/react';

import { AccommodationPricingWrapperProps } from './accommodation-pricing.props';

const AccommodationConfigurationForm = dynamic(
    () =>
        import('@app/components/molecules/accommodation-configuration-form').then(
            c => c.AccommodationConfigurationForm,
        ),
    { ssr: true },
);
const AccommodationPricing = dynamic(
    () => import('./accommodation-pricing').then(c => c.AccommodationPricing),
    { ssr: true },
);

const CancellationDetailsModal = dynamic(
    () =>
        import('@app/components/organisms/cancellation-details-modal').then(
            x => x.CancellationDetailsModal,
        ),
    { ssr: false },
);

const ApartmentDetailsModal = dynamic(
    () =>
        import('@app/components/organisms/pricing-modals/apartment-details-modal').then(
            x => x.ApartmentDetailsModal,
        ),
    { ssr: false },
);

const ApartmentsListModal = dynamic(
    () =>
        import('@app/components/organisms/pricing-modals/apartments-list-modal').then(
            x => x.ApartmentsListModal,
        ),
    { ssr: false },
);

export const AccommodationPricingWrapper = forwardRef<HTMLDivElement, any>(
    (
        {
            withModals = true,
            expandedMobileView = false,
            ...props
        }: AccommodationPricingWrapperProps,
        ref,
    ) => {
        const { t } = useTranslation('accommodation', {
            keyPrefix: 'pricing',
        });

        return (
            <>
                <Box ref={ref} {...props}>
                    <Heading
                        size={'md'}
                        mb={{
                            base: 4,
                            md: 2,
                        }}
                        hideBelow={expandedMobileView ? undefined : 'md'}
                    >
                        {t('pricingHeader')}
                    </Heading>
                    <AccommodationConfigurationForm mb={6} />
                    <AccommodationPricing
                        bestOfferMobileProps={
                            expandedMobileView
                                ? {
                                      withMoreDetails: true,
                                      showHeading: false,
                                      apartmentBookButtonProps: {
                                          variant: 'solid',
                                          display: 'flex',
                                          ml: 'auto',
                                          mb: 2,
                                          w: 'auto',
                                          minW: '9em',
                                      },
                                  }
                                : undefined
                        }
                    />
                </Box>
                {withModals ? (
                    <>
                        <ApartmentsListModal />
                        <ApartmentDetailsModal />
                        <CancellationDetailsModal />
                    </>
                ) : null}
            </>
        );
    },
);

AccommodationPricingWrapper.displayName = 'AccommodationPricing';
